import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { Button } from '@/components/ui/button';
import FavoriteHeart from '@/components/FavoriteHeart';
import SmartImage from '@/components/SmartImage';

const tierLabel = (tier) => (tier === 'premium' ? 'Premium Luxe' : 'Essential Pick');

export const ProductCard = ({ product, onOpen }) => {
  return (
    <Card
      className="card-hover overflow-hidden bg-card border-border/70 rounded-2xl shadow-[0_8px_24px_rgba(31,26,23,0.05)] flex flex-col"
      data-testid="product-card"
      data-product-id={product.id}
    >
      <div className="relative">
        <AspectRatio ratio={4 / 3}>
          <SmartImage
            src={product.image_url}
            alt={product.name}
            fallbackKind="product"
            className="h-full w-full object-cover bg-cream"
          />
        </AspectRatio>
        <div className="absolute top-3 right-3">
          <FavoriteHeart
            type="product"
            id={product.id}
            testId={`product-favorite-toggle-${product.id}`}
          />
        </div>
        <div className="absolute top-3 left-3">
          <Badge
            className={`text-[10px] uppercase tracking-[0.14em] font-medium border ${
              product.tier === 'premium'
                ? 'bg-accent text-ink border-rose-tint'
                : 'bg-card text-foreground border-border'
            }`}
          >
            {tierLabel(product.tier)}
          </Badge>
        </div>
      </div>
      <div className="p-4 sm:p-5 flex flex-col flex-1">
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
          {product.brand}
        </span>
        <h3 className="mt-1 font-display text-xl font-semibold leading-tight text-ink">
          {product.name}
        </h3>
        <p className="mt-1.5 text-sm text-muted-foreground line-clamp-2 leading-relaxed">
          {product.description}
        </p>
        <div className="mt-3 flex items-center gap-2 text-xs text-muted-foreground">
          <span className="font-medium text-foreground">{product.price_range}</span>
          <span>·</span>
          <span className="capitalize">{product.category}</span>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {(product.benefits || []).slice(0, 2).map((b) => (
            <span
              key={b}
              className="text-[11px] tracking-[0.04em] text-rose-gold border border-rose-tint bg-accent/40 rounded-full px-2 py-0.5"
            >
              {b}
            </span>
          ))}
        </div>
        <div className="mt-auto pt-4">
          <Button
            variant="outline"
            size="sm"
            className="rounded-xl w-full"
            onClick={() => onOpen?.(product)}
            data-testid={`product-detail-open-${product.id}`}
          >
            View details
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default ProductCard;
